
import titles from '@/store/lang/titles.json';
import { mapGetters, mapActions } from "vuex";
import Success from "../success/Success.vue";
import Tooltip from "../tooltip/tooltip.vue";
import InvisibleRecaptcha from "vue-invisible-recaptcha";
export default {
  name: "CreditApplication",
  components: {
    Success,
    Tooltip,
    InvisibleRecaptcha
  },
  data() {
    return {
      creditApplicationTitles: titles.creditApplicationTitles,
      rulesTitle: titles.rulesTitle.creditApplication,
      applicationFormInfo: false,
      panelOpen: 0,
      isCreditApplicationTick: false,
      isCreditApplicationValid: false,
      isBankcruptcyValid: false,
      bankcruptcyTick: false,
      datePickerTick: false,
      dunsTick: false,
      companyInfoTick: false,
      isOtherFormsCompleteTick: false,
      isDigitalSignature: false,
      isDigitalSignatureTick: false,
      hoverCondition: false,
      rules: {
        nameRules: [
          v => !!v || titles.rulesTitle.creditApplication.fieldIsRequired,
        ],
        accountContactNameRules: [
          v => !!v || titles.rulesTitle.creditApplication.fullName,
        ],
        zipCodeRules: [
          v => !!v || titles.rulesTitle.creditApplication.zipCode,
          v =>  v.length >= 5 || titles.rulesTitle.creditApplication.validZipcode
        ],
        emailRules: [
          v => !!v || titles.rulesTitle.creditApplication.email,
          v => /.+@.+/.test(v) || titles.rulesTitle.creditApplication.validEmail,
        ],
        phoneNumberRules: [
          v => !!v || titles.rulesTitle.creditApplication.phoneNumber,
          function (v) {
            if (v) {
              let value = v.replace(/\D/g, '');
              return (!isNaN(parseFloat(value)) && value.length == 10) || titles.rulesTitle.creditApplication.validPhoneNum
            }
            return titles.rulesTitle.creditApplication.validPhoneNum
          }
        ],
        digitalSignatureRules: [
          v => !!v || titles.rulesTitle.creditApplication.digitalSignature,
        ]
      },
      requestForm: {
        "event_type": "credit_application",
        "business_name": "",
        "additional_info": "",
        "account_pay_info": {
          "email": "",
          "name": "",
          "phone": ""
        },
        "business_addr": {
          "city": "",
          "state": "",
          "street": "",
          "zipCode": ""
        },
        "attachment": {
          "content": null,
          "file_name": "",
          "file_type": "",
          "bucket": "credit-application-files",
        },
        "duns": "",
        "established_date": "",
        "isBankrupted": null,
        "signature": "",
        "CountryCode": ""
      },
      isSubmitSuccessful: false,
      menu: false,
      creditRefFile: null,
      fileType: null,
      fileName: null,
      errorFileUpload: "",
      activeStep: 1,
      animation: 'animate-in',
      date: "",
      dateFormatted: "",
      isSubmitting: false
    };
  },
  computed: {
    ...mapGetters(["getCountryCode"]),
    progress(){
      
      var pg =  (this.activeStep-1)/ 6*100;
      
      return pg;

    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  methods: {
    ...mapActions(["addFormRequest"]),
    validateCreditApplicationField() {
      this.isCreditApplicationValid = this.$refs.creditApplicationForm.validate();
      this.isCreditApplicationTick = this.isCreditApplicationValid;
      this.$refs.creditApplicationForm.validate();
    },
    validateBankcruptcyField() {
      this.isBankcruptcyValid = this.$refs.bankcruptcyForm.validate();
      this.bankcruptcyTick = this.isBankcruptcyValid;
      this.$refs.bankcruptcyForm.validate();
    },
    validateDigitalSignatureField() {
      this.isDigitalSignature = this.$refs.digitalSignatureForm.validate();
      this.isDigitalSignatureTick = this.isDigitalSignature;
      this.$refs.digitalSignatureForm.validate();
    },
    getPriorPanel(event, idx) {
      event ? event.preventDefault() : null;
      switch (idx) {
        case 2:
          this.priorStep();
          break;
        case 3:
          this.priorStep();
          break;
          case 4:
          this.priorStep();
          break;
        case 5:
          this.priorStep();
          break;
        case 6:
          this.priorStep();
          break;
        case 7:
          this.priorStep();
          break;
      }
    },
    getNextPanel(event, idx) {
      event.preventDefault();
      switch (idx) {
        case 1:
          this.validateCreditApplicationField();
          !this.isCreditApplicationValid
            ? this.notValid()
            : this.nextStep();
          break;
        case 2:
          this.validateBankcruptcyField();
          !this.isBankcruptcyValid ? this.notValid()
            : this.nextStep();
          break;
        case 3:
          this.datePickerTick = true;
          this.requestForm.established_date = this.dateFormatted;
          this.nextStep();
          break;
        case 4:
          this.dunsTick = true;
          this.nextStep();
          break;
        case 5:
          this.companyInfoTick = true;
          this.nextStep();
          break;
        case 6:
          this.isOtherFormsCompleteTick = true; this.nextStep();
          break;
        case 7:
          this.validateDigitalSignatureField();
          !this.isRentalPickupRequirementValid
            ? this.notValid()
            : this.nextStep();
          break;
      }
    },
    onFileSelected(event) {
      this.errorFileUpload = "";
      let file = event;
      if (file.size / 1000000 > 2) {
        this.errorFileUpload = "*File size should be less than 2MB";
        return;
      }
      if (!file.type.includes("pdf")) {
        this.errorFileUpload = "*Only pdf is allowed";
        return;
      }
      this.requestForm.attachment.file_type = file.type;
      this.requestForm.attachment.file_name = file.name;
      let reader = new FileReader();
      reader.onloadend = () => {
        this.requestForm.attachment.content = reader.result;
      };
      reader.readAsDataURL(file);
    },
    submit() {
      this.requestForm.CountryCode = this.getCountryCode;
      this.validateDigitalSignatureField();
      if (this.isDigitalSignature) {
        this.isSubmitting = true;
        this.panelOpen = null;
        this.addFormRequest({
          data: this.requestForm,
          event_type: this.requestForm.event_type
        }).then(response => {
          if (
            response &&
            response.data &&
            response.data.ResponseMetadata &&
            response.data.ResponseMetadata.HTTPStatusCode == 200
          ) {
            this.isSubmitSuccessful = true;
            this.isSubmitting = false;
          }
        })
          .catch((err) => {
            console.log(err);
            this.isSubmitting = false;
          });
      } else {
        this.panelOpen = 6;
      }
    },
    getRequestForm() {
      this.requestForm = {
        "event_type": "credit_application",
        "business_name": "",
        "additional_info": "",
        "account_pay_info": {
          "email": "",
          "name": "",
          "phone": ""
        },
        "business_addr": {
          "city": "",
          "state": "",
          "street": "",
          "zipCode": ""
        },
        "attachment": {
          "content": null,
          "file_name": "",
          "file_type": "",
          "bucket": "credit-application-files",
        },
        "duns": "",
        "established_date": "",
        "isBankrupted": null,
        "signature": "",
        "CountryCode": this.getCountryCode
      };
      this.isSubmitSuccessful = false;
      this.activeStep = 1;
      this.isCreditApplicationTick = false;
      this.bankcruptcyTick = false;
      this.datePickerTick = false;
      this.dunsTick = false;
      this.companyInfoTick = false;
      this.isOtherFormsCompleteTick = false;
      this.isDigitalSignatureTick = false;
      this.creditRefFile = null;
      this.fileName = null;
      this.fileType = null;
    },
    priorStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep -= 1;
      }, 600);
    },
    nextStep() {
      this.animation = 'animate-out';
      setTimeout(() => {
        this.animation = 'animate-in';
        this.activeStep += 1;
      }, 600);
    },
    notValid() {
      this.animation = 'animate-wrong';
      setTimeout(() => {
        this.animation = '';
      }, 400);
    },
    getStepperContent(step) {
      this.activeStep = step;
      switch (step) {
        case 1: this.isCreditApplicationTick = false; break;
        case 2: this.bankcruptcyTick = false; break;
        case 3: this.datePickerTick = false; break;
        case 4: this.dunsTick = false; break;
        case 5: this.companyInfoTick = false; break;
        case 6: this.isOtherFormsCompleteTick = false; break;
        case 7: this.isDigitalSignatureTick = false; break;
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    isAllValid() {
      return !(this.isCreditApplicationTick && this.bankcruptcyTick && this.requestForm.signature)|| this.isSubmitting;
    },
    submitted(response) {
      /*resposne will have the reCAPTCHA token.
      If token is null or empty do nothing.*/
      if (!response) return;
      this.submit();
    }
  },
};

